import { Link } from 'react-router-dom';

interface SettingsTabLinkProps {
  tab: {
    id: string;
    name: string;
    path: string;
    icon: React.ComponentType<{ className?: string }>;
  };
  isActive: boolean;
}

export function SettingsTabLink({ tab, isActive }: SettingsTabLinkProps) {
  const Icon = tab.icon;

  return (
    <Link
      to={`/app/settings/${tab.path}`}
      className={`
        group inline-flex items-center py-4 px-1 font-medium text-sm
        ${
          isActive
            ? 'text-indigo-600 dark:text-indigo-400 border-b-2 border-indigo-600 dark:border-indigo-400'
            : 'text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 border-b-2 border-transparent'
        }
      `}
      aria-current={isActive ? 'page' : undefined}
    >
      <Icon
        className={`-ml-0.5 mr-2 h-5 w-5 pointer-events-none ${
          isActive
            ? 'text-indigo-600 dark:text-indigo-400'
            : 'text-gray-400 dark:text-gray-500 group-hover:text-indigo-600 dark:group-hover:text-indigo-400'
        }`}
        aria-hidden="true"
      />
      {tab.name}
    </Link>
  );
}

export function SettingsTabOption({
  tab,
}: {
  tab: { id: string; name: string };
}) {
  return <option value={tab.id}>{tab.name}</option>;
}
